import { OfferSessionStorage } from '../../types/Offer';
import { Offer } from '../../types';
const ADDED_OFFERS_KEY = 'candycart-added-offers';

function getCurrentOfferOnMatch(
  alreadyAddedOffers: OfferSessionStorage[],
  offerToAdd: Offer,
) {
  return alreadyAddedOffers.find((addedOffer) => {
    const idsMatch = addedOffer.id === offerToAdd.id;
    if (idsMatch && offerToAdd.shopify_product_variant_id) {
      return (
        addedOffer.shopify_product_variant_id ===
        offerToAdd.shopify_product_variant_id
      );
    } else {
      return idsMatch;
    }
  });
}

function saveAddedOffer(offerToAdd: Offer) {
  let alreadyAddedOffers = getAddedOffers();
  const currentOffer = getCurrentOfferOnMatch(alreadyAddedOffers, offerToAdd);

  if (currentOffer) {
    currentOffer.quantity = offerToAdd.quantity;
  } else {
    alreadyAddedOffers = [
      ...alreadyAddedOffers,
      {
        id: offerToAdd.id,
        shopify_product_variant_id: offerToAdd.shopify_product_variant_id,
        quantity: offerToAdd.quantity,
        note: offerToAdd.note,
      },
    ];
  }
  sessionStorage.setItem(ADDED_OFFERS_KEY, JSON.stringify(alreadyAddedOffers));
}

function cleanupStaleAddedRecommendedProducts(
  offerId: number,
  variantsIds: number[],
) {
  sessionStorage.setItem(
    ADDED_OFFERS_KEY,
    JSON.stringify([
      ...getAddedOffers().filter((o: OfferSessionStorage) => {
        return !(
          o.id === offerId &&
          !variantsIds.includes(o.shopify_product_variant_id)
        );
      }),
    ]),
  );
}

function removeOffer(offer: Offer | OfferSessionStorage, variantId?: number) {
  sessionStorage.setItem(
    ADDED_OFFERS_KEY,
    JSON.stringify([
      ...getAddedOffers().filter(
        (o: OfferSessionStorage) =>
          !(offer.id === o.id && o.shopify_product_variant_id === variantId),
      ),
    ]),
  );
}

function getAddedOffers(): OfferSessionStorage[] {
  const data = sessionStorage.getItem(ADDED_OFFERS_KEY);
  if (data) {
    try {
      return JSON.parse(data);
    } catch (error) {
      return [];
    }
  }
  return [];
}

export {
  saveAddedOffer,
  cleanupStaleAddedRecommendedProducts,
  removeOffer,
  getAddedOffers,
};
